import React from "react";
import styled from "styled-components";
import { AmplitudeService } from "@analytics/Amplitude/AmplitudeService";
import IconButton from "@common/LifeAtButton/Variants/IconButton";
import { CallToActionContextType, useCallToActionContext } from "@contexts/CallToActionContext";
import { UserContextType, useUserContext } from "@contexts/UserContext";
import RoomChatBtnIcon from "@resources/icons/Rooms/Room-Chat-Icon.svg";
import { SignUpCTASource } from "@user/AmplitudeUserEvents";
import { ToggleRoomChat } from "../../../../features/room/room-chat/AmplitudeRoomChatEvents";
import { ChatContextType, useChatContext } from "../../../../features/room/room-chat/ChatContext";
import HideOnMobileScreenSizes from "../../TopNavigation/TopNavigationComponents/HideOnMobileScreenSizes";

const BtnIcon = styled(RoomChatBtnIcon)`
    stroke: ${(props) => props.theme.iconColor};
    stroke-width: 1.5;
`;

function RoomChatButton() {
    const amplitudeService = AmplitudeService.getInstance();

    const { setSignInView }: CallToActionContextType = useCallToActionContext();
    const { isChatOpen, setIsChatOpen }: ChatContextType = useChatContext();
    const { user }: UserContextType = useUserContext();

    const toggleRoomChatOpen = () => {
        if (user) {
            const toggledIsChatOpen = !isChatOpen;
            setIsChatOpen(toggledIsChatOpen);

            if (toggledIsChatOpen) {
                amplitudeService.logEvent(new ToggleRoomChat({ source: "overlay_button" }));
            }
        } else {
            setSignInView(SignUpCTASource.ROOM_CHAT);
        }
    };

    return (
        <HideOnMobileScreenSizes>
            <IconButton variant={"normal"} size={"normal"} onClick={toggleRoomChatOpen}>
                <BtnIcon />
            </IconButton>
        </HideOnMobileScreenSizes>
    );
}
export default RoomChatButton;
